<template>
  <scroll-box
    :offset-top="152"
    :stop="isFinished"
    :bottom="300"
    :canLoading="canLoading"
    :onReachBottom="handleReachBottom"
    @onAffix="val => (this.affix = val)"
  >
    <div id="tpl-public" class="templage-public">
      <swiper :list="bannerList" @click-item="handleLink"></swiper>
      <el-tabs
        v-model="activeType"
        :class="{ affix: affix }"
        class="g-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="tab in tagsList"
          :key="tab.id"
          :label="tab.name"
          :name="tab.id"
        ></el-tab-pane>
      </el-tabs>
      <waterfall-list
        :list="dataList"
        :is-empty="tagsList.length === 0 || isEmpty"
        :is-finished="isFinished"
        finished-text="以上为全部模板"
        style="padding: 16px 8px 0;"
      >
        <template v-slot:item="slotProps">
          <div class="waterfall-item">
            <el-image
              class="waterfall-item-img"
              :src="
                slotProps.item.templates[0].defaultUrl +
                  '?imageView&thumbnail=300x0'
              "
              fit="cover"
              @click.native="handleItemClick(slotProps.item)"
            ></el-image>
            <div
              class="waterfall-item-tag"
              v-if="slotProps.item.type === 'PPT'"
            >
              {{ slotProps.item.type }}
            </div>
          </div>
        </template>
      </waterfall-list>
    </div>
  </scroll-box>
</template>

<script>
import Swiper from '@/components/swiper'
import WaterfallList from '@/components/waterfall-list'
import { brand_logo_url, template_type_free, template_type_multiple, template_type_ppt, template_type_single } from '@/const.js'
import routerMixin from '@/mixins/router-mixin.js'
import templateService from '@/request/service/template-service'
import { mapActions, mapGetters } from 'vuex'
// import Affix from '@/components/affix'
// import templateList from '../components/template/template-list-index'
export default {
  components: {
    WaterfallList,
    Swiper
    // templateList
  },
  mixins: [routerMixin],
  props: {},
  data () {
    return {
      canLoading: false,
      affix: false,
      listInfo: {
        total: null,
        pageNum: 0,
        pageSize: 60
        // id: '',
        // tagNames: [],
        // widthHeights: []
      },
      activeType: '',
      pptType: template_type_ppt,
      singleType: template_type_single,
      freeType: template_type_free,
      multiType: template_type_multiple,
      dataList: [],
      bannerList: [
        {
          keyName: 'public_blankTemplate',
          img: require('/public/img/index/empty-tpl.png'),
          src: () => {
            return `/#/tplFree/${this.blankTemplateId}/editor`
          },
          title: '创建空白模板',
          subtitle: ''
        },
        {
          hidden: false,
          keyName: 'public_ai',
          img: require('/public/img/index/ai-design.png'),
          src:'https://dubhe.netease.com/#/ai/editor',
          title: 'AI商品背景生成&nbsp;&nbsp;<span style="display: inline-block; color: #FDFDFD; background: #2BC2A4; border-radius: 2px; font-size: 12px; padding: 1px 4px;">Beta</span>',
          subtitle: '智能生成商品背景',
        },
        {
          keyName: 'public_cutout',
          img: require('/public/img/index/auto-ps.png'),
          src: '/#/img/ps',
          title: '智能抠图',
          subtitle: 'AI自动消除背景'
        },
        {
          keyName: 'public_ps',
          img: require('/public/img/index/online-ps.png'),
          src: '/#/ps/online',
          title:
            '在线PS&nbsp;&nbsp;<span style="display: inline-block; color: #FDFDFD; background: #2BC2A4; border-radius: 2px; font-size: 12px; padding: 1px 4px;">Beta</span>',
          subtitle: 'PS平替，无需安装，在线作图'
        },
        {
          keyName: 'group_materials',
          img: require('/public/img/index/group-materials.png'),
          src: brand_logo_url,
          title: '集团素材下载',
          subtitle: '各部门logo、IP形象、常用图片素材'
        },
        {
          keyName: 'public_designCustom',
          img: require('/public/img/index/custom-design.png'),
          src: 'https://dc.netease.com/#/?type=5',
          title: '设计定制服务',
          subtitle: '品牌设计、IP设计、高频模板设计等'
        },
        {
          keyName: 'public_tvAd',
          img: require('/public/img/index/tv-put.png'),
          src:
            'https://hz.oa.netease.com/oaWebV4/index.jsp#/flow/create?workflowId=10097',
          title: '电视广告投放',
          subtitle: '会议室电视轮播广告位'
        },
        {
          keyName: 'public_adminAd',
          img: require('/public/img/index/av-put.png'),
          src:
            'https://hz.oa.netease.com/oaWebV4/index.jsp#/flow/create?workflowId=456',
          title: '行政广告投放',
          subtitle: '餐厅、电梯、卫生间、大门等广告位'
        },
        {
          img: require('/public/img/index/more-tools.png'),
          src: '',
          title: '更多工具...',
          subtitle: '设计百宝箱，敬请期待'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      blankTemplateId: 'app/blankTemplateId',
      tagsList: 'app/categoryList',
      projectId: 'app/publicProjectId',
      aigcProjectId: 'app/aigcProjectId'
    }),
    isFinished () {
      return (
        this.listInfo.total !== null &&
        this.dataList.length >= this.listInfo.total
      )
    },
    isEmpty () {
      return (
        this.isFinished &&
        this.dataList.length === 0 &&
        this.listInfo.total === 0
      )
    }
    // tagsList () {
    //   return this.$store.state.app.templateIndexTags
    // },
    // projectId () {
    //   return this.$store.state.app.loginUser.publicProject.id
    // }
  },
  watch: {
    tagsList (val) {
      if (val && val.length > 0) {
        this.activeType = val[0].id
        this.getDataList()
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions({
      getTplCategoryList: 'app/getTplCategoryList'
    }),
    init () {
      this.getTags()
      // AI做图的banner展示显示/隐藏
      const user = this.$store.state.app.loginUser
      this.bannerList[1].hidden = !user.dubheAiVisible
    },
    getTags () {
      this.getTplCategoryList(this.projectId)
      // this.$store.dispatch('app/queryTemplateIndexTagList', this.projectId)
      // this.$store.dispatch('app/queryTemplateTagList', this.projectId)
    },
    clearListInfo () {
      this.dataList = []
      this.listInfo.total = null
      this.listInfo.pageNum = 0
    },
    handleClick (tab, e) {
      this.clearListInfo()
      this.getDataList(() => {
        this.affix = false
      })
    },
    handleReachBottom () {
      return new Promise((resolve, reject) => {
        this.getDataList(resolve, reject)
      })
    },
    handleLink (item) {
      let { src, keyName } = item
      keyName && this.saveUserAction(
        this.ActionType.publicTemplate.name.key,
        keyName
      )
      if (typeof src === 'function') {
        src = src()
      }
      src && window.open(src, '_blank')
    },
    getDataList (onResolve, onReject) {
      const params = {
        ...this.listInfo,
        projectId: this.projectId,
        pageNum: ++this.listInfo.pageNum,
        categoryId: this.activeType
        // tagNames: [this.activeType]
      }
      templateService
        .getTemplateList(params)
        .then(d => {
          this.dataList = [...this.dataList, ...d.list]
          this.listInfo.total = d.total
          onResolve && onResolve()
        })
        .catch(e => {
          onReject && onReject()
        })
        .finally(() => {
          this.canLoading = true
        })
    },
    handleItemClick (data) {
      let item = data.templates[0]
      if (item.type !== template_type_single) {
        this.saveUserAction(
          this.ActionType.template.name.key,
          this.ActionType.templateGroup.edit.key,
          item.type,
          item.id
        )
      } else {
        this.saveUserAction(
          this.ActionType.template.name.key,
          this.ActionType.template.edit.key,
          item.type,
          item.id
        )
      }
      this.forwardMapping(data.type, item.id, item.free)
    },
    forwardMapping (type, id, free) {
      if (free) {
        this.goToTplFreeEditor(id)
        return
      }
      let obj = {}
      obj[this.pptType] = () => {
        this.goToTplGroupEditor(id)
      }
      obj[this.multiType] = () => {
        this.goToTplGroupEditor(id)
      }
      obj[this.singleType] = () => {
        this.toUse(id)
      }
      let func = obj[type]
      func && func()
    },
    toUse (id) {
      const tplRouter = this.$router.resolve({
        path: '/template/' + id + '/editor',
        param: {
          id: id
        }
      })
      window.open(tplRouter.href, '_blank')
    },
    goToTplGroupEditor (id) {
      const tplGroupRouter = this.$router.resolve({
        path: '/templateGroup/' + id + '/editor'
      })
      window.open(tplGroupRouter.href, '_blank')
    },
    goToTplFreeEditor (id) {
      const tplFreeRouter = this.$router.resolve({
        path: '/tplFree/' + id + '/editor'
      })
      window.open(tplFreeRouter.href, '_blank')
    }
  },
  beforeDestroy () {}
}
</script>
<style lang="scss">
@import './template.scss';
.templage-public {
  position: relative;
}
</style>
